<template>
  <CommonDialog :show.sync="show" dialog-title="Group Buy Rules and Procedure" class="desc-dialog" top="calc(50vh - 210px)">
    <template v-slot:body>
      <div class="content">
        <div class="step">
          <div class="title">
            Step 1: Set up a Group/ Join a Group
          </div>
          <p>Go to page on class details, and click "Join a Group" to join a group that is soon to be full;</p>
          <img v-lazy-load data-src="~assets/images/group-buy-activity/join_pic.png" alt="">
          <div class="line" />
          <p>or click "X People in Group Buy" to launch a new group</p>
          <img v-lazy-load data-src="~assets/images/group-buy-activity/group_buy_pic.png" alt="">
        </div>
        <div class="step">
          <div class="title">
            Step 2: Invite friends to join group
          </div>
          <p>Go to class details page, and click "Join Group Buy" to join a group that is soon to be full;</p>
          <img v-lazy-load data-src="~assets/images/group-buy-activity/invite_pic.png" alt="">
        </div>
        <div class="step">
          <div class="title">
            Step 3: Invite your friends to join your Group Buy
          </div>
          <img v-lazy-load data-src="~assets/images/group-buy-activity/join_group_buy.png" alt="">
        </div>
        <div class="step">
          <div class="title">
            Step 4: Complete Group Buy Successfully
          </div>
          <p>Group Buys will only be successful when groups hit full capacity. If not reached, group buy will be unsuccessful, and refunds will be made via the same method as the original payment.</p>
          <img v-lazy-load data-src="~assets/images/group-buy-activity/complete_pic.png" alt="">
        </div>
      </div>
    </template>
  </CommonDialog>
</template>

<script>
import CommonDialog from 'components/common/CommonDialog/index.vue';

export default {
  components: {
    CommonDialog,
  },
  props: {

  },
  data() {
    return {
      show: false,
    }
  },
  methods: {
    openDialog() {
      this.show = true
    },
  },
}
</script>

<style lang="scss" scoped>
.desc-dialog /deep/ .common-dialog-template .dialog-body {
  background: #fff;
  height: 482px;
  overflow-y: scroll;
  padding: 16px 20px;
}

.content {
  .step {
    width: 100%;
    padding: 20px 16px;
    background: var(--txt-color-link3);
    border-radius: 10px;
    margin-bottom: 14px;

    .title {
      font-size: 16px;
      font-weight: 600;
      color: var(--txt-color-link);
      line-height: 19px;
      padding-bottom: 20px;
    }

    .line {
      width: 100%;
      height: 1px;
      background: #f7edd7;
      margin: 20px 0;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      color: #555;
      line-height: 16px;
    }

    img {
      width: 432px;
      margin-top: 12px;
    }
  }
}
</style>
